import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/api';
import Swal from 'sweetalert2';


const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: ''
  });
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [agreedPolicies, setAgreedPolicies] = useState({
    terms: false,
    privacy: false,
    refund: false,
  });
  const [activePolicyTab, setActivePolicyTab] = useState('terms');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const navigate = useNavigate();

  const handleSignUpClick = (e) => {
    e.preventDefault();
    setShowPolicyModal(true);
    setAgreedPolicies({ terms: false, privacy: false, refund: false });
    setActivePolicyTab('terms');
  };

  const allPoliciesAgreed = agreedPolicies.terms && agreedPolicies.privacy && agreedPolicies.refund;

  const handleConfirmRegister = () => {
    if (!allPoliciesAgreed) return;
    setShowPolicyModal(false);

    api.post('/users/register', formData)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Registration Successful',
          text: 'Please login to continue'
        });
        navigate('/signIn');
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: 'error',
          title: 'Registration Failed',
          text: 'An error occurred while registering. Please try again.'
        });
      });
  };

  const termsContent = (
    <div className="space-y-6 text-gray-700">
      <p className="mb-6">
        Welcome to hirelanka.com.These Terms and Conditions govern your use of
        our website and the purchase of subscriptions from our platform. By
        accessing and using our website, you agree to comply with these terms.
        Please read them carefully before proceeding with any transactions.
      </p>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Use of the Website
        </h3>
        <div className="space-y-2">
          <p>
            a. You must be at least 18 years old to use our website or to
            purchase the subscription
          </p>
          <p>
            b. You are responsible for maintaining the confidentiality of your
            account information, including your username and password.
          </p>
          <p>
            c. You agree to provide accurate and current information during the
            registration and checkout process.
          </p>
          <p>
            d.The prices for your needed service is decided by the service
            provider (The vehicle owner/The person who's number is included in
            the information) and our website doesn't hold any accountability
            between the deals, pricing and any other interactions between the
            service users and the service providers
          </p>
          <p>
            e. You may not use our website for any unlawful or unauthorized
            purposes.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Subscription and Pricing
        </h3>
        <div className="space-y-2">
          <p>
            a. We strive to provide accurate product descriptions, images
            However, we do not guarantee the accuracy or completeness of such
            information.
          </p>
          <p>
            b. The only charge that is included in our website is the
            subscription fee that the service provider has to purchase the
            subscription in order to keep their vehicles on our site.The
            subscription is LKR.750/- per month and if you are a service
            provider you have to purchase this subscription.Once you make the
            purchase no additional charges will appear and you will get charged
            again exactly after 30 days.The service user doesn't has to pay any
            amount of money to use our website more details about this is
            mentioned in our return policy
          </p>
          <p>
            c. The charge for your hire is decided by the Vehicle owners that
            you choose from our website and we do not interfere with any
            financial decisions between the service user and the service
            provider this may be subject to additional terms and conditions.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Orders and Payments
        </h3>
        <div className="space-y-2">
          <p>
            a. By placing an order on our website, you are making an offer to
            purchase the selected products.
          </p>
          <p>
            b. We reserve the right to refuse or cancel any order for any
            reason, including but not limited to service availability, errors in
            a service information, or suspected fraudulent activity.
          </p>
          <p>
            c. You agree to provide valid and up-to-date payment information and
            authorize us to charge the total order amount, including applicable
            taxes to your chosen payment methods
          </p>
          <p>
            d. We use trusted third-party payment processors to handle your
            payment information securely. We do not store or have access to your
            full payment details.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Refunds</h3>
        <p>
          a. Our Returns and Refund Policy governs the process and conditions
          for seeking refunds. Please refer to the policy provided on our
          website for more information.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Intellectual Property
        </h3>
        <div className="space-y-2">
          <p>
            a. All content and materials on our website, including but not
            limited to text, images, logos, and graphics, are protected by
            intellectual property rights and are the property of hirelanka.com
            or its licensors.
          </p>
          <p>
            b. You may not use, reproduce, distribute, or modify any content
            from our website without our prior written consent.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Limitation of Liability
        </h3>
        <div className="space-y-2">
          <p>
            a. In no event shall hirelanka.com , its directors, employees, or
            affiliates be liable for any direct, indirect, incidental, special,
            or consequential damages arising out of or in connection with your
            use of our website or the purchase and use of our services
          </p>
          <p>
            b. We make no warranties or representations, express or implied,
            regarding the quality, accuracy, or suitability of the services
            offered on our website.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Amendments and Termination
        </h3>
        <p>
          We reserve the right to modify, update, or terminate these Terms and
          Conditions at any time without prior notice. It is your responsibility
          to review these terms periodically for any changes.
        </p>
      </section>
    </div>
  );

  const privacyContent = (
    <div className="space-y-6 text-gray-700">
      <p className="mb-6">
        At Hirelanka.com, we are committed to protecting the privacy and
        security of our customers' personal information. This Privacy Policy
        outlines how we collect, use, and safeguard your information when you
        visit to use our services on our website. By using our website, you
        consent to the practices described in this policy.
      </p>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Information We Collect
        </h3>
        <p className="mb-4">
          When you visit our website, we may collect certain information about
          you, including:
        </p>
        <div className="space-y-2 mb-4">
          <p>
            Personal identification information (such as your name, email
            address, and phone number) provided voluntarily by you during the
            registration or purchasing the subscription information necessary to
            process your experience including credit card details, which are
            securely handled by trusted third-party payment processors.
          </p>
          <p>
            Browsing information, such as your IP address, browser type, and
            device information, collected automatically using cookies and
            similar technologies.
          </p>
        </div>
        <p className="mb-4">
          Information posted on hirelanka.com is publicly available. If you
          choose to provide us with personal information, you are consenting to
          the transfer and storage of that information on our servers. We
          collect and store the following personal information:
        </p>
        <div className="space-y-2">
          <p>
            Email address, contact information, and (depending on the service
            used) sometimes financial information.
          </p>
          <p>
            Computer sign-on data, statistics on page views, traffic to and from
            ikman and response to advertisements.
          </p>
          <p>
            Other information, including users' IP address and standard web log
            information.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Use</h3>
        <p className="mb-4">We use users' personal information to:</p>
        <div className="space-y-2">
          <p>Provide our services</p>
          <p>Resolve disputes, collect fees, and troubleshoot problems</p>
          <p>Encourage safe trading and enforce our policies</p>
          <p>Customize users experience, measure interest in our services</p>
          <p>
            Improve our services and inform users about services and updates
          </p>
          <p>
            Communicate marketing and promotional offers to you according to
            your preferences
          </p>
          <p>
            Do other things for users as described when we collect the
            information
          </p>
        </div>
        <p className="mt-4 mb-4">
          We may use the following third-party service providers to monitor and
          analyze the use of our service. Each of the service providers links to
          their privacy policy that talks about how they use your data.
        </p>
        <div className="space-y-1">
          <p>Facebook</p>
          <p>Google</p>
          <p>X</p>
          <p>Instagram</p>
          <p>Tik tok</p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Disclosure</h3>
        <div className="space-y-4">
          <p>
            We don't sell or rent users' personal information to third parties
            for their marketing purposes without users' explicit consent. We may
            disclose personal information to respond to legal requirements,
            enforce our policies, respond to claims that a posting or other
            content violates other's rights, or protect anyone's rights,
            property, or safety.
          </p>
          <p>
            hirelanka.com will share your phone number or email address,
            pictures of your vehicle and conditions of your vehicle with the
            service users whom contacted or shown interest to your vehicle
            through our platform.We do this to make sure both parties get the
            best possible offers and service that they have shown an active
            interest in. You hereby give consent to such sharing of phone number
            and or e-mail ID,Pictures of your vehicle,information and condition
            of your vehicles
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Security</h3>
        <div className="space-y-4">
          <p>
            We use lots of tools (encryption, passwords, physical security) to
            protect your personal information against unauthorized access and
            disclosure.
          </p>
          <p>
            All personal electronic details will be kept private by the Service
            except for those that you wish to disclose.
          </p>
          <p>
            It is unacceptable to disclose the contact information of others
            through the Service.
          </p>
          <p>
            If you violate the laws of your country of residence and/or the
            terms of use of the Service you forfeit your privacy rights over
            your personal information.
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Unsubscribe information
        </h3>
        <p>
          If at any time you wish to have your information reviewed or removed
          from our active databases, please contact us at
          hirelankapvtltd@gmail.com
        </p>
      </section>

      <div className="space-y-4">
        <p>
          This website makes use of Display Advertising, and uses Remarketing
          technology with Google Analytics to advertise online. Third-party
          vendors, including Google, may show our ads on various websites across
          the Internet, using first-party cookies and third-party cookies
          together to inform, optimize, and serve ads based on past visits to
          our website.
        </p>
        <p>
          Visitors can opt-out of Google Analytics for Display Advertising and
          customize Google Display Network ads using the Ads Preferences
          Manager.
        </p>
      </div>
    </div>
  );

  const refundContent = (
    <div className="space-y-6 text-gray-700">
      <p className="mb-6">
        Thank you for joining with Hirelanka to use our services.We value your
        satisfaction and strive to provide you with the best online service
        experience possible. If, for any reason, you are not completely
        satisfied with your service, we are here to help.
      </p>

      <p className="mb-6">
        When you put your vehicle on our website you have to purchase the
        subscription for a fee of LKR.750/- per month.We provide one free
        complimentary month to ensure that you get benefited from our website if
        not you could easily cancel your subscription at anytime.After the first
        30 days (complimentary month) you will be billed for your subscription
        for the first time.
      </p>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Refunds</h3>
        <div className="space-y-4">
          <p>
            If you wish to cancel your subscription after the first month please
            cancel your subscription before two days to the billing date
          </p>
          <p>
            If you wish to cancel your subscription after getting billed your
            account will be close at the end of your current billing cycle and
            you won't be charged again but the charged fees will note be
            refunded after you were billed .Just simply cancel your subscription
            just before the billing date to avoid any misunderstandings
          </p>
        </div>
      </section>

      <section>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Contact Us</h3>
        <p>
          If you have any questions or concerns regarding our refund policy,
          please contact our customer support team. We are here to assist you
          and ensure your service experience with us is enjoyable and
          hassle-free.
        </p>
      </section>
    </div>
  );

  const policyData = {
    terms: { title: 'Terms & Conditions', content: termsContent },
    privacy: { title: 'Privacy Policy', content: privacyContent },
    refund: { title: 'Refund Policy', content: refundContent },
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#eff1f3] px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="px-8 pt-6 pb-4 text-center">
          <h2 className="text-2xl font-bold tracking-tight text-gray-900">
            Create Account
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Please fill in your details to register
          </p>
        </div>

        <form className="px-8 pb-6 space-y-4" onSubmit={handleSignUpClick}>
          {/* First Name Input */}
          <div className="space-y-2">
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
              First Name
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-[#a9b9e3]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <input
                id="firstName"
                name="firstName"
                type="text"
                required
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                className="w-full pl-10 pr-3 py-2 border border-[#a9b9e3] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6f48e5] focus:border-[#6f48e5] transition-colors duration-200"
              />
            </div>
          </div>

          {/* Last Name Input */}
          <div className="space-y-2">
            <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
              Last Name
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-[#a9b9e3]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <input
                id="lastName"
                name="lastName"
                type="text"
                required
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                className="w-full pl-10 pr-3 py-2 border border-[#a9b9e3] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6f48e5] focus:border-[#6f48e5] transition-colors duration-200"
              />
            </div>
          </div>

          {/* Email Input */}
          <div className="space-y-2">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-[#a9b9e3]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <input
                id="email"
                name="email"
                type="email"
                required
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
                className="w-full pl-10 pr-3 py-2 border border-[#a9b9e3] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6f48e5] focus:border-[#6f48e5] transition-colors duration-200"
              />
            </div>
          </div>

          {/* Phone Number Input */}
          <div className="space-y-2">
            <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">
              Phone Number
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-[#a9b9e3]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <input
                id="phoneNumber"
                name="phoneNumber"
                type="tel"
                required
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="w-full pl-10 pr-3 py-2 border border-[#a9b9e3] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6f48e5] focus:border-[#6f48e5] transition-colors duration-200"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={!formData.firstName || !formData.lastName || !formData.email || !formData.phoneNumber}
            className="w-full py-2 px-4 mt-6 bg-[#6f48e5] hover:bg-[#5a3ac4] text-white text-sm font-medium rounded-lg transition-colors duration-200 disabled:bg-[#a9b9e3] disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#6f48e5]"
          >
            Register
          </button>
        </form>

        <div className="px-8 pb-6 text-center">
          <p className="text-sm text-gray-600">
            Already have an account?{' '}
            <button
              onClick={() => navigate('/signIn')}
              className="text-[#6f48e5] hover:text-[#5a3ac4] font-medium focus:outline-none"
            >
              Login
            </button>
          </p>
        </div>
      </div>

      {/* Policy Agreement Modal */}
      {showPolicyModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] flex flex-col overflow-hidden">
            {/* Modal Header */}
            <div className="px-6 py-4 border-b bg-gradient-to-r from-[#6f48e5] to-[#5a3ac4]">
              <h2 className="text-xl font-bold text-white">Review Our Policies</h2>
              <p className="text-sm text-purple-200 mt-1">Please read and agree to all policies before registering</p>
            </div>

            {/* Policy Tabs */}
            <div className="flex border-b">
              {Object.entries(policyData).map(([key, policy]) => (
                <button
                  key={key}
                  onClick={() => setActivePolicyTab(key)}
                  className={`flex-1 px-4 py-3 text-sm font-medium transition-all duration-200 relative ${
                    activePolicyTab === key
                      ? 'text-[#6f48e5] border-b-2 border-[#6f48e5] bg-purple-50'
                      : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <span className="flex items-center justify-center gap-2">
                    {agreedPolicies[key] && (
                      <svg className="h-4 w-4 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                    {policy.title}
                  </span>
                </button>
              ))}
            </div>

            {/* Policy Content */}
            <div className="flex-1 overflow-y-auto px-6 py-4" style={{ maxHeight: '40vh' }}>
              {policyData[activePolicyTab].content}
            </div>

            {/* Agreement Checkboxes */}
            <div className="px-6 py-4 border-t bg-gray-50 space-y-3">
              {Object.entries(policyData).map(([key, policy]) => (
                <label
                  key={key}
                  className="flex items-center gap-3 cursor-pointer group"
                  onClick={() => setActivePolicyTab(key)}
                >
                  <input
                    type="checkbox"
                    checked={agreedPolicies[key]}
                    onChange={(e) => {
                      e.stopPropagation();
                      setAgreedPolicies(prev => ({ ...prev, [key]: !prev[key] }));
                    }}
                    className="w-4 h-4 text-[#6f48e5] border-gray-300 rounded focus:ring-[#6f48e5] cursor-pointer"
                  />
                  <span className={`text-sm ${agreedPolicies[key] ? 'text-green-700 font-medium' : 'text-gray-600 group-hover:text-gray-800'}`}>
                    I have read and agree to the <span className="font-semibold">{policy.title}</span>
                  </span>
                </label>
              ))}
            </div>

            {/* Modal Actions */}
            <div className="px-6 py-4 border-t flex gap-3">
              <button
                onClick={() => setShowPolicyModal(false)}
                className="flex-1 py-2.5 px-4 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmRegister}
                disabled={!allPoliciesAgreed}
                className={`flex-1 py-2.5 px-4 rounded-lg font-medium text-sm transition-all duration-200 ${
                  allPoliciesAgreed
                    ? 'bg-[#6f48e5] hover:bg-[#5a3ac4] text-white shadow-md hover:shadow-lg'
                    : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                }`}
              >
                {allPoliciesAgreed ? 'Agree & Register' : 'Please agree to all policies'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;